import { PagedResponse } from './../../interfaces/paged-response.inteface';
import { Feriado } from '@tivic-team/manager-ts/dist/grl/entities/feriado.entity';
import { Injectable } from '@angular/core';
import { ApiService } from '../api-service.interface';
import { FeriadoController } from 'app/controllers/grl/feriado.controller';
import { LoaderService } from '../loader.service';
import { FeriadoSearch } from './feriado.search';

@Injectable({
  providedIn: 'root'
})
export class FeriadoService implements ApiService<Feriado>{

    constructor(
        private _feriadoController: FeriadoController, 
        private _loaderService: LoaderService
    ) {}

    find(search?: FeriadoSearch): Promise<PagedResponse<Feriado>> {
        this._loaderService.show();
        return this._feriadoController.find((search && search.getFilters()) || null).finally(() => this._loaderService.hide());
    }

    get(id: number): Promise<Feriado> {
        this._loaderService.show();
        return this._feriadoController.get(id).finally(() => this._loaderService.hide());
    }
    
    create(entity: Feriado): Promise<Feriado> {
        this._loaderService.show();
        return this._feriadoController.create(entity).finally(() => this._loaderService.hide());
    }
    
    update(entity: Feriado): Promise<Feriado> {
        this._loaderService.show();
        return this._feriadoController.update(entity).finally(() => this._loaderService.hide());
    }

    save(feriado: Feriado): Promise<Feriado> {
        this._loaderService.show();

        if (feriado.cdFeriado && feriado.cdFeriado > 0) {
            return this._feriadoController.update(feriado).finally(() => this._loaderService.hide());
        } else {
            return this._feriadoController.create(feriado).finally(() => this._loaderService.hide());
        }
    }

}
